export const BASE_URL = "https://api.witscript.com/api";
